import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {IconType, IoniconsOutline, ND} from "@pt/pt-models";

@Component({
  selector: 'pt-details-app-score',
  template: `
    <div class="pt-details-app-score">
      <div class="pt-details-app-score-title">
        {{ title }}
        <pt-icon
          *ngIf='titleHelp'
          [iconType]='iconType'
          [key]='iconKey'
          [ngbTooltip]='titleHelp'
          class="d-flex"
          container='body'
          placement='top-right'
          tooltipClass='input-confirm-password-help-tooltip'
          triggers='click'
        ></pt-icon>
      </div>
      <div class="pt-details-app-score-value">
        <div class="app-score-value" [ngClass]="{'app-store-no-value': currentValue === ND}">
          {{ currentValue }}
        </div>
      </div>
    </div>
  `,
  styles: [`
    .pt-details-app-score {
      display: flex;
      flex-direction: column;
    }
    .app-score-value {
      display: inline-flex;
      cursor: default;
      width: max-content;
      min-width: 30px;
      text-align: center;
      padding: 2px 5px;
      align-items: center;
      border: 2px solid #28a745;
      border-radius: 20px;
      justify-content: space-around;
      font-weight: bold;
    }
    .app-store-no-value {
      border-color: grey;
    }

    .pt-details-app-score-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      font-size: 15px;
      font-weight: bold;
    }

    .pt-details-app-score-value {
      display: inline-flex;
      height: 50px;
      align-items: center;
      margin-right: 10px;
      cursor: default;
      min-width: 150px;
    }
  `]
})
export class DetailsSingleValueComponent implements OnChanges {
  @Input() title: string;
  @Input() titleHelp?: string;
  @Input() value?: number;

  public iconKey = IoniconsOutline.infoCircle;
  public iconType = IconType.IONIC_ICON;
  ND = ND;
  public currentValue: string = ND;
  ngOnChanges(changes: SimpleChanges): void {
    this.currentValue = this.value ? this.value.toString() : ND;
  }
}
